import { MediaStateEntity } from '@/stores/media-state/media-state.type';

export const MEDIA_STATE_DEFAULT_VALUE: MediaStateEntity = {
  sm: false,
  md: false,
  lg: false,
  xl: false,
};
